/* Dependencies
 ----------------------------------------------------------*/
import {Application} from "../plugins/_application";

/* Vendor
 ----------------------------------------------------------*/


/* Setup
 ----------------------------------------------------------*/
var app = window.app = new Application(window.options || {});

/* Services
 ----------------------------------------------------------*/


/* Register services
 ----------------------------------------------------------*/

/* Modules
 ----------------------------------------------------------*/
import Navigation from "../modules/_navigation";
import NavigationScroll from '../modules/_navigation-scroll';
import PageTransition from "../modules/_page-transition";
import ObjectFit from "../modules/_object-fit";
import Print from "../modules/_print";
import SocialShare from '../modules/_social-share';
import SmoothScroll from "../modules/_smooth-scroll";
import Faq from "../modules/_faq";
import ContactForm from "../modules/_contact-form";
import LogoSlider from "../modules/_logo-slider";

/* Register modules
 ----------------------------------------------------------*/
app.use(Navigation);
app.use(NavigationScroll);
app.use(PageTransition);
app.use(ObjectFit);
app.use(Print);
app.use(SocialShare);
app.use(SmoothScroll);
app.use(Faq);
app.use(ContactForm);
app.use(LogoSlider);